import * as React from 'react';
import { MainMenuItem, DropMenuProps, DropMenuState } from './MainMenu.types';
import { KeyboardEventKeys } from '../../utils/keyboardEventKeys';

/**
 * Renders the dropdown menu for the [[MainMenu]]
 */
export class DropMenu extends React.Component<DropMenuProps, DropMenuState> {
  private _groupRef: HTMLElement;
  private _itemList: HTMLAnchorElement[] = [];
  constructor(props: DropMenuProps) {
    super(props);
    this.state = { focusedItemIndex: -1 };
  }

  componentDidMount = () => {
    const { items } = this.props;

    this._itemList.forEach((item, i) => {
      if (items[i].Url === window.location.pathname) {
        item.setAttribute('aria-current', 'page');
      }
    });

    // Scope keydown event to only _groupRef and its descendants
    this._groupRef.addEventListener('keydown', (e) => {
      switch (e.key) {
        case KeyboardEventKeys.arrowDown:
          this.setNextFocus();
          break;
        case KeyboardEventKeys.arrowUp:
          this.setPreviousFocus();
          break;
      }
    });
  };

  componentDidUpdate = (prevProps: DropMenuProps) => {
    if (prevProps.expanded !== this.props.expanded) {
      if (this.props.expanded) {
        // If this component updates and its expanded prop is set to true
        // we set focus on the first element in this itemList.
        this.setState({ focusedItemIndex: 0 }, () => {
          this._itemList[0].focus();
        });
      }
    }
  };

  setNextFocus = () => {
    const { focusedItemIndex } = this.state;
    const listLength = this._itemList.length;
    let targetIndex = focusedItemIndex + 1;
    // If targetIndex is out of bounds, we loop it back to the start
    if (targetIndex >= listLength) targetIndex = 0;

    this.setState({ focusedItemIndex: targetIndex }, () => {
      this._itemList[targetIndex].focus();
    });
  };

  setPreviousFocus = () => {
    const { focusedItemIndex } = this.state;
    const listLength = this._itemList.length;
    let targetIndex = focusedItemIndex - 1;
    // If targetIndex is out of bounds, we loop it back to the end
    if (targetIndex < 0) targetIndex = listLength - 1;

    this.setState({ focusedItemIndex: targetIndex }, () => {
      this._itemList[targetIndex].focus();
    });
  };

  renderItem = (item: MainMenuItem, mapIndex: number) => {
    const { index, focusCb } = this.props;
    let activeNode = +item.Selected || item.PathSelected ? ' main-navigation__link--active' : '';
    let attributes = {
      href: item.Url,
      className: `main-navigation__link ${activeNode}`,
      tabIndex: -1,
    } as React.HTMLAttributes<any>;

    return (
      <li key={item.Url}>
        <a ref={(el) => (this._itemList[mapIndex] = el)} {...attributes}>
          {item.Name}
        </a>
      </li>
    );
  };

  render() {
    const { id, items, labelledBy } = this.props;
    return (
      <ul
        ref={(el) => (this._groupRef = el)}
        id={id}
        aria-labelledby={labelledBy}
        className="main-navigation__subnav drop-shadow-high-elevation">
        {items.map(this.renderItem)}
      </ul>
    );
  }
}
